import e from "react";
import { componentName as r } from "../../../utils/bem/index.js";
function i(i) {
  var t = i.size,
    o = i.color,
    s = r("spinner", i.className),
    n = {
      width: t,
      height: t,
      borderWidth: t / 10
    };
  return o && (n["--spinner-color"] = o), e.createElement("i", {
    style: n,
    className: s
  });
}
i.defaultProps = {
  size: 18
};
export { i as Spinner };